import styled from 'styled-components';

export const TooltipText = styled.div`
  color: var(--white);
  text-align: center;  
  cursor: pointer;
  margin-left: 5px;
`;

export const TooltipBox = styled.div`
  position: absolute;
  bottom: calc(100% + 5px);
  right: 0;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  width: 0;
  padding: 5px 5px;
  border-radius: 4px;
  transition: visibility 0.2s, color 0.2s, background-color 0.2s, width 0.2s, opacity 0.5s
  padding 0.2s ease-in-out;
  opacity: 0;

  @media all and (min-width: 768px) {
    bottom: calc(100% + 10px);
  }

  &:before {
    content: "";
    width: 0;
    height: 0;
    right: 5px;
    bottom: -3px;
    position: absolute;
    border: 3px solid transparent;
    transform: rotate(315deg);
    transition: border 0.1s ease-in-out;
  }
`;
export const TooltipCard = styled.div`
  position: relative;
  & ${TooltipText}:hover + ${TooltipBox} {
    visibility: visible;
    color: white;
    background-color: var(--mid-gray-rgb);
    width: 180px;
    padding: 4px 8px;
    opacity: 1;
    display: flex;
    justify-content: center;

   

    &:before {
      border-color: transparent transparent var(--mid-gray-rgb)
      var(--mid-gray-rgb);
    }

    @media all and (min-width: 768px) {
      width: ${({ width }) => (width || '579px')};
    }
  }
`;

export const ToolTipBoxText = styled.span`
  font-size: 10px;
  line-height: 14px;
  color: white;
`;
